export const FETCH_MYPLANS_ACTION = "FETCH_MYPLANS_ACTION";
export const FETCH_MYPLANS_FAIL_ACTION = FETCH_MYPLANS_ACTION + "_ERROR";
export const FETCH_MYPLANS_SUCCESS_ACTION = FETCH_MYPLANS_ACTION + "_SUCCESS";

export const SUBSCRIBE_PLAN_ACTION = "SUBSCRIBE_PLAN_ACTION";
export const SUBSCRIBE_PLAN_FAIL_ACTION = SUBSCRIBE_PLAN_ACTION + "_ERROR";
export const SUBSCRIBE_PLAN_SUCCESS_ACTION = SUBSCRIBE_PLAN_ACTION + "_SUCCESS";

export const FETCH_SUBSCRIPTION_ACTION = "FETCH_SUBSCRIPTION_ACTION";
export const FETCH_SUBSCRIPTION_FAIL_ACTION = FETCH_SUBSCRIPTION_ACTION + "_ERROR";
export const FETCH_SUBSCRIPTION_SUCCESS_ACTION = FETCH_SUBSCRIPTION_ACTION + "_SUCCESS";

export const DELETE_SUBSCRIPTION_ACTION = "DELETE_SUBSCRIPTION_ACTION";
export const DELETE_SUBSCRIPTION_FAIL_ACTION = DELETE_SUBSCRIPTION_ACTION + "_ERROR";
export const DELETE_SUBSCRIPTION_SUCCESS_ACTION = DELETE_SUBSCRIPTION_ACTION + "_SUCCESS";

export const FETCH_SUB_PAYMENTMODE_ACTION = "FETCH_SUB_PAYMENTMODE_ACTION";
export const FETCH_SUB_PAYMENTMODE_FAIL_ACTION = FETCH_SUB_PAYMENTMODE_ACTION + "_ERROR";
export const FETCH_SUB_PAYMENTMODE_SUCCESS_ACTION = FETCH_SUB_PAYMENTMODE_ACTION + "_SUCCESS";

export const CREATE_INVOICE_ACTION = "CREATE_INVOICE_ACTION";
export const CREATE_INVOICE_FAIL_ACTION = CREATE_INVOICE_ACTION + "_ERROR";
export const CREATE_INVOICE_SUCCESS_ACTION = CREATE_INVOICE_ACTION + "_SUCCESS";

export const CREATE_PAYMENT_ACTION = "CREATE_PAYMENT_ACTION";
export const CREATE_PAYMENT_FAIL_ACTION = CREATE_PAYMENT_ACTION + "_ERROR";
export const CREATE_PAYMENT_SUCCESS_ACTION = CREATE_PAYMENT_ACTION + "_SUCCESS";


export const FETCH_RUNNER_BYID_ACTION = "FETCH_RUNNER_BYID_ACTION";
export const FETCH_RUNNER_BYID_FAIL_ACTION = FETCH_RUNNER_BYID_ACTION + "_ERROR";
export const FETCH_RUNNER_BYID_SUCCESS_ACTION = FETCH_RUNNER_BYID_ACTION + "_SUCCESS";

export const SUBSCRIBE_BANKPLAN_ACTION = "SUBSCRIBE_BANKPLAN_ACTION";
export const SUBSCRIBE_BANKPLAN_FAIL_ACTION = SUBSCRIBE_BANKPLAN_ACTION + "_ERROR";
export const SUBSCRIBE_BANKPLAN_SUCCESS_ACTION = SUBSCRIBE_BANKPLAN_ACTION + "_SUCCESS";

export const FETCH_RUNNER_USER_ACTION = "FETCH_RUNNER_USER_ACTION";
export const FETCH_RUNNER_USER_FAIL_ACTION = FETCH_RUNNER_USER_ACTION + "_ERROR";
export const FETCH_RUNNER_USER_SUCCESS_ACTION = FETCH_RUNNER_USER_ACTION + "_SUCCESS";

export const FETCH_SUBSCRIPTION_LOG_ACTION = "FETCH_SUBSCRIPTION_LOG_ACTION";
export const FETCH_SUBSCRIPTION_LOG_FAIL_ACTION = FETCH_SUBSCRIPTION_LOG_ACTION + "_ERROR";
export const FETCH_SUBSCRIPTION_LOG_SUCCESS_ACTION = FETCH_SUBSCRIPTION_LOG_ACTION + "_SUCCESS";

export const FETCH_TOTALSUBSCRPTN_ACTION = "FETCH_TOTALSUBSCRPTN_ACTION";
export const FETCH_TOTALSUBSCRPTN_FAIL_ACTION = FETCH_TOTALSUBSCRPTN_ACTION + "_ERROR";
export const FETCH_TOTALSUBSCRPTN_SUCCESS_ACTION = FETCH_TOTALSUBSCRPTN_ACTION + "_SUCCESS";

export const SUBSCRIBE_LOG_ACTION = "SUBSCRIBE_LOG_ACTION";
export const SUBSCRIBE_LOG_FAIL_ACTION = SUBSCRIBE_LOG_ACTION + "_ERROR";
export const SUBSCRIBE_LOG_SUCCESS_ACTION = SUBSCRIBE_LOG_ACTION + "_SUCCESS";

export const FETCH_SUB_CARGOSIZE_ACTION = "FETCH_SUB_CARGOSIZE_ACTION";
export const FETCH_SUB_CARGOSIZE_FAIL_ACTION = FETCH_SUB_CARGOSIZE_ACTION + "_ERROR";
export const FETCH_SUB_CARGOSIZE_SUCCESS_ACTION = FETCH_SUB_CARGOSIZE_ACTION + "_SUCCESS";


export const EXPIRE_STATUSCHANGE_ACTION = "EXPIRE_STATUSCHANGE_ACTION";
export const EXPIRE_STATUSCHANGE_FAIL_ACTION = EXPIRE_STATUSCHANGE_ACTION + "_ERROR";
export const EXPIRE_STATUSCHANGE_SUCCESS_ACTION = EXPIRE_STATUSCHANGE_ACTION + "_SUCCESS";


export const FETCH_HISTORYSUBSCRIPTION_ACTION = "FETCH_HISTORYSUBSCRIPTION_ACTION";
export const FETCH_HISTORYSUBSCRIPTION_FAIL_ACTION = FETCH_HISTORYSUBSCRIPTION_ACTION + "_ERROR";
export const FETCH_HISTORYSUBSCRIPTION_SUCCESS_ACTION = FETCH_HISTORYSUBSCRIPTION_ACTION + "_SUCCESS";

export const CLEAR_SUBSCRIPTIONLOG_ACTION = "CLEAR_SUBSCRIPTIONLOG_ACTION";